<script setup>
import { ref, reactive, computed, onMounted, defineComponent, getCurrentInstance, onBeforeUnmount, defineEmits, defineExpose } from 'vue'
import { useRoute, useRouter, RouterLink, RouterView } from 'vue-router'
import { showToast } from 'vant';
import JSMpeg from 'jsmpeg-player';
import copy from 'copy-to-clipboard'
import { userInfoStore, rewardListStore } from '@/stores/counter.js'
import { getReqData, getHomeConfigAPI, loginoutAPI, getCommunicationAPI, sendGiftCodeAPI } from '@/util/api'

const route = useRoute()
const router = useRouter()
let { proxy } = getCurrentInstance()

const emit = defineEmits(['needLogin', 'goPayPage', 'goBinding', 'goNextPage'])
const needLogin = () => {
  emit('needLogin');
}
const goPayPage = () => {
  emit('goPayPage')
}
const goNext = () => {
  emit('goNextPage')
}

const userStore = userInfoStore()
const rewardStore = rewardListStore()
const userInfo = computed(() => {
  return userStore.userInfo
})
const videoCanvas = ref()
const configData = ref('')
const showBindingGifPop = ref(false)
const showBindingGifPop2 = ref(false)
const communication = ref('')
const bingdingEmail = ref('')
const noPlay = ref(true)
const playerVideo = ref('')

const agree = ref(false)
let isWait = ref(false)
const timeOut1 = ref(null)
const count1 = ref(60)

// const needLogin = () => {
//   console.log('【登陆】');
//   proxy.$mitt.emit('needLogin', '去登陆')
// }
const loginout = () => {
  loginoutAPI(getReqData({})).then(res => {
    if (res.data.code == 0) {
      showToast({ type: 'success', message: res.data.msg, className:'toast-success' })
      userStore.setUserInfo('')
      localStorage.removeItem('2G19fZeORY8=')
      localStorage.removeItem('FiJISxKHfpo=')
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
// const goPayPage = () => {
//   if (!userInfo.value) {
//     proxy.$mitt.emit('needLogin', '去登陆')
//     return
//   }
//   router.push('/trade_m')
// }
const getHomeConfig = () => {
  getHomeConfigAPI().then(res => {
    if (res.data.code == 0) {
      console.log('【首页配置】', res.data.data);
      configData.value = res.data.data
      localStorage.setItem('config-record', JSON.stringify(res.data.data))
    } else {
      showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
    }
  }).catch(err => {
    console.log('[error]', err);
  })
}
const toAppStor = () => {
  window.location.href = configData.value.download[1].value
}
const toGgStor = () => {
  window.location.href = configData.value.download[0].value
}
const toFb = () => {
  window.location.href = configData.value.download[2].value
}
const toNaver = () => {
  window.location.href = 'https://cafe.naver.com/hllcmt'
}
const getCommunication = () => {
    let reqData = {
      pgid: 59,
      uid: userInfo.value.uid,
      uname: userInfo.value.uname,
      token: userInfo.value.token
    }
    getCommunicationAPI(getReqData(reqData)).then(res => {
      if (res.data.code == 0) {
        console.log('【用户绑定信息】', res.data.data);
        communication.value = res.data.data
        bingdingEmail.value = communication.value.email.replace(
        /(\d{3})\d*(\d{2})/,
        "$1****$2"
      );
      } else {
        showToast({ type: 'fail', message: res.data.msg, className:'toast-fail' })
      }
    }).catch(err => {
      console.log('[error]', err);
    })
  }
  const claimGif = () => {
    console.log('【communication.value】', communication.value, userInfo.value);
    if (!userInfo.value) {
      // proxy.$mitt.emit('needLogin', '去登陆')
      needLogin()
      return
    }
    if (communication.value.email) {
      showBindingGifPop2.value = true
    } else {
      showBindingGifPop.value = true
    }
    
    
  }
  const goBD = () => {
    // router.push('/user_info_m')
    emit('goBinding')
  }
  const sendGiftCode = () => {
    let reqData = {
      uname: userInfo.value.uname,
      uid: userInfo.value.uid,
      token: userInfo.value.token,
      pgid: 59,
      pid: 45,
      gid: 1000796,
      rid: 310,
      email: communication.value.email
    }
    sendGiftCodeAPI(getReqData(reqData)).then(res => {
      if (res.data.code == 0) {
        showToast({ type: 'success', message: res.data.msg, className:'toast-success' })
        showBindingGifPop2.value = false
      } else {
        showToast({ type: 'fail', message: res.data.msg.msg, className:'toast-fail' })
      }
    }).catch(err => {
      console.log('[error]', err);
    })
  }

const delayedCode = () => {
  if (count1.value > 0) {
    timeOut1.value = setTimeout(() => {
      count1.value--
      delayedCode()
    }, 1000)
  } else {
    clearTimeout(timeOut1.value)
    isWait.value = false
    count1.value = 60
  }
}

const joinFb = () => {
  childRef3.value.updateTaskStatus(3)
}
const joinDs = () => {
  childRef3.value.updateTaskStatus(4)
}
const doCopy = (text) => {
  copy(text)
  showToast({ type: 'success', message: 'Link copied successfully, go ahead and share it!', className:'toast-success' })
}
const initVideoStream = () => {
  const videoUrl = 'https://onepiece.hllcmt.com/static/ts/video1.ts';
  playerVideo.value = new JSMpeg.VideoElement(videoCanvas.value, videoUrl, { autoplay: true,
    poster: 'https://onepiece.hllcmt.com/static/ts/video1.png',
    loop: true,
    control: false,
    disableGl: false,
    progressive: false,
    preserveDrawingBuffer: false,
    decodeFirstFrame: false
  }, 
  { audio: false, onPlay: () => {
    console.log('【开始播放】');
  } })
}
const routerTo = (info) => {
  console.log('【跳转】', info);
  
  router.push(info)
}
const palyAudio = () => {
  if (document.getElementById('audioHomem') && noPlay.value) {
    document.getElementById('audioHomem').play()
    noPlay.value = false
  }
}
const stopAudio = () => {
  if (document.getElementById('audioHomem')) {
    document.getElementById('audioHomem').pause()
    noPlay.value = true
  }
}

const audioPlay = () => {
  if (noPlay.value == false) {
    palyAudio()
  }
}

defineExpose({ audioPlay, palyAudio, stopAudio, getCommunication })

onMounted(() => {
  getHomeConfig()
  if (userInfo.value) {
    getCommunication()
  }
  initVideoStream()
})
onBeforeUnmount(() => {
  playerVideo.value.destroy()
  console.log('【销毁】');
  
})
</script>

<template>
  <section class="home-box" @click="palyAudio">
    <section ref="videoCanvas" class="videoBox" style="width: 100%; height: 100%;"></section>
    <!-- <aside style="display: flex; justify-content: center; align-items: flex-start; padding-top: 0.7rem; position: relative;"> -->
      <aside style="position: absolute; top:0.7rem; left: 15px; width: 40px; display: flex; flex-direction: column; align-items: center;">
        <img src="@/assets/img/nav/fb-nav-icon.png" alt="" @click="toFb" style="width: 40px;">
        <img v-if="!(communication.email && communication.giftcode.email == 1)" src="@/assets/img/01p/gif-icon.png" alt="" @click.stop="claimGif" style="width: 40px; margin-top: 12px;">
        <img src="@/assets/img/01p/naver-icon.png" alt="" @click="toNaver" style="width: 40px; margin-top: 12px;">
      </aside>
      <img src="@/assets/img/01p/logo.png" alt="" style="width: 140px; position: absolute; top: 0.8rem; left: 50%; transform: translateX(-50%);">
      <aside v-if="userInfo" class="out-box">
        <span style="margin-right: 6px;">{{ userInfo.uname }}</span>
        <button class="out-btn" @click="loginout">로그아웃</button>
      </aside>
      <img v-else src="@/assets/img/01p/login-btn.png" alt="" @click.stop="needLogin" style="position: absolute; top: 0.7rem; right: 12px; width: 54px;">
      <aside style="position: absolute; right: 12px; top: 1.2rem; padding: 4px; border-radius: 8px; background-color: rgb(255 255 255 / 60%); display: flex; justify-content: center; align-items: center;">
        <img v-if="noPlay" @click="palyAudio" src="@/assets/img/01p/audio-btn1.png" alt="" style="width: 24px;">
        <img v-else @click.stop="stopAudio" src="@/assets/img/01p/audio-btn2.png" alt="" style="width: 24px;">
      </aside>
    <!-- </aside> -->
    <section class="shop-box">
      <aside style="display: flex; flex-direction: column; align-items: center;">
        <aside style="display: flex; justify-content: center; align-items: center; margin-bottom: 0.08rem;">
          <img src="@/assets/img/01p/btn0102.png" alt="" @click="goPayPage()" style="height: 0.44rem; margin-right: 0.09rem;">
          <!-- <img src="@/assets/img/01p/as-xz.png" alt="" @click="toAppStor" style="height: 0.3rem; margin-left: 0.09rem;"> -->
        </aside>
        <aside style="display: flex; justify-content: center; align-items: center;">
          <!-- <img src="@/assets/img/01p/pay-btn.png" alt="" @click="goPayPage" style="height: 0.3rem; margin-right: 0.09rem;"> -->
          <img src="@/assets/img/01p/as-xz.png" alt="" @click="toAppStor" style="height: 0.3rem; margin-left: 0.09rem;">
          <img src="@/assets/img/01p/ad-xz.png" alt="" @click="toGgStor" style="height: 0.3rem; margin-left: 0.09rem;">
        </aside>
      </aside>
      <img src="@/assets/img/01p/jt-icon.png" alt="" @click="goNext()" style="height: 0.34rem; margin: 0.34rem 0rem 0.08rem;">
    </section>
    <section class="mask-box" v-if="showBindingGifPop">
      <section class="mask-content">
        <aside style="display: flex; justify-content: flex-end; align-items: center; height: 38px; width: 100%;">
          <img src="@/assets/img/nav/close-icon.png" alt="" @click="showBindingGifPop = false" style="height: 28px; margin-right: 12px;">
        </aside>
        <img src="@/assets/img/04p/lq-title.png" alt="" style="height: 20px; margin-top: 18px;">
        <img src="@/assets/img/04p/send-tips02.png" alt="" style="width: 324px; margin-top: 24px;">
        <span style="font-size: 14px; margin: 12px 0px 24px;">{{ '메일 연동:' + bdEmail }}</span>
        <aside style="display: flex; justify-content: center;">
          <img src="@/assets/img/04p/config-btn.png" alt="" @click="goBD" style="height: 40px; margin-right: 25px;">
          <img src="@/assets/img/04p/close-btn.png" alt="" @click="showBindingGifPop = false" style="height: 40px; margin-left: 25px;">
        </aside>
      </section>
    </section>
    <section class="mask-box" v-if="showBindingGifPop2">
      <section class="mask-content">
        <aside style="display: flex; justify-content: flex-end; align-items: center; height: 38px; width: 100%;">
          <img src="@/assets/img/nav/close-icon.png" alt="" @click="showBindingGifPop2 = false" style="height: 28px; margin-right: 12px;">
        </aside>
        <img src="@/assets/img/04p/lq-title.png" alt="" style="height: 20px; margin-top: 18px;">
        <img src="@/assets/img/04p/send-tips.png" alt="" style="width: 324px; margin-top: 24px;">
        <span style="font-size: 14px; margin: 12px 0px 24px;">{{ '메일 연동:' + bingdingEmail }}</span>
        <aside style="display: flex; justify-content: center;">
          <img src="@/assets/img/04p/config-btn.png" alt="" @click="sendGiftCode" style="height: 40px; margin-right: 25px;">
          <img src="@/assets/img/04p/close-btn.png" alt="" @click="showBindingGifPop2 = false" style="height: 40px; margin-left: 25px;">
        </aside>
      </section>
    </section>
    <audio id="audioHomem" loop="loop">
      <source src="@/assets/img/01p/home.mp3" type="audio/mpeg">
    </audio>
  </section>
</template>

<style scoped>
.home-box {
  width: 100%;
  height: 100vh;
  position: relative;
  background: url('../../assets/img/01p/bac.jpg') no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
}
.shop-box {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mask-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(0 0 0 / 80%);
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.mask-content {
  width: 354px;
  height: 294px;
  background: url('../../assets/img/nav/login-bac.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.text-sys2 {
  font-size: 14px;
  font-weight: bolder;
  color: #9d4f23;
  /* text-shadow: -0.2px -0.2px 0 #fff1d6, 0.2px -0.2px 0 #fff1d6, -0.2px 0.2px 0 #fff1d6, 0.2px 0.2px 0 #fff1d6; */
}
.text-sys3 {
  font-size: 14px;
  /* font-weight: bolder; */
  color: #443421;
  /* text-shadow: -0.2px -0.2px 0 #fff1d6, 0.2px -0.2px 0 #fff1d6, -0.2px 0.2px 0 #fff1d6, 0.2px 0.2px 0 #fff1d6; */
}
.out-box {
  background: rgb(139, 173, 216);
  position: absolute;
  right: 12px;
  top: 0.7rem;
  height: 20px;
  font-size: 12px;
  font-weight: bold;
  padding: 4px 6px;
  border-radius: 6px;
  color: rgb(67, 116, 167);
  display: flex;
  align-items: center;
}
.out-btn {
  border-radius: 4px;
  border: none;
  background: none;
  color: #ffffff;
  font-size: 12px;
  padding: 2px 3px;
}
.videoBox {
  object-fit: cover;
  z-index: 0;
}
</style>
